import axios from "axios";
import { API_ENDPOINTS } from "../Utils/ApiEndPoints";
import axiosInstance from "../Utils/axiosInstance";
class ApprovalProcessService{
    static async getDropDownListData(category){
        try{
          
            const url = API_ENDPOINTS.getDropDownListAll(category);
            const token = localStorage.getItem('token');
            const response = await axiosInstance.get(url,{
            headers:{
                "Content-Type": "application/json",
                "Authorization": `Bearer ${token}`
            },
          });
          const result = response.data;
          if(result.result.length > 0){
            
            return { success: true,data:result };
          }else {
            
            return { success: false, data: result };
          }
        }
        catch(error){
            console.error("Error Occured:",error)
        }
    }

    static async getRequestDetails(id){
      try{
        
          const url = API_ENDPOINTS.getRequestDetails(id);
          const token = localStorage.getItem('token');
          const response = await axiosInstance.get(url,{
          headers:{
              "Content-Type": "application/json",
              "Authorization": `Bearer ${token}`
          },
        });
        const result = response.data;
        if(result.result.length > 0){
          
          return { success: true,data:result };
        }else {
          
          return { success: false, data: result };
        }
      }
      catch(error){
          console.error("Error Occured:",error)
      }
  }

    static async getApproverDropDownListData(search){
      try{
        
          const url = API_ENDPOINTS.getApproverDropDownListAll(search);
          const token = localStorage.getItem('token');
          const response = await axiosInstance.get(url,{
          headers:{
              "Content-Type": "application/json",
              "Authorization": `Bearer ${token}`
          },
        });
        const result = response.data;
        if(result.result.length > 0){
          
          return { success: true,data:result };
        }else {
          
          return { success: false, data: result };
        }
      }
      catch(error){
          console.error("Error Occured:",error)
      }
  }

  static async getApproverDetails(id){
    try{
      
        const url = API_ENDPOINTS.getApproverDetails(id);
        const token = localStorage.getItem('token');
        const response = await axiosInstance.get(url,{
        headers:{
            "Content-Type": "application/json",
            "Authorization": `Bearer ${token}`
        },
      });
      const result = response.data;
      if(result.result.length > 0){
        
        return { success: true,data:result };
      }else {
        
        return { success: false, data: result };
      }
    }
    catch(error){
        console.error("Error Occured:",error)
    }
}
    
    static async CreateApproval(formData) {
        try {
          const url = API_ENDPOINTS.InsertApprover();
          const token = localStorage.getItem('token');
          const response = await axios.post(url, formData, {
            headers: {
                "Authorization": `Bearer ${token}`
            },
          });
          
          const resultndData = response.data;
          if(resultndData.result> 0){
            
            return { success: true,data:resultndData };
          }else {
            
            return { success: false, data: resultndData };
          }
        } catch (error) {
          console.error("Error creating ticket:", error);
          return { success: false };
        }
      }

      static async UpdateApproval(fd) {
        try {
          const url = API_ENDPOINTS.UpdateApprover();
          const token = localStorage.getItem('token');
          const response = await axios.post(url, fd, {
            headers: {
                "Authorization": `Bearer ${token}`
            },
          });
          
          const resultndData = response.data;
          if(resultndData.result> 0){
            
            return { success: true,data:resultndData };
          }else {
            
            return { success: false, data: resultndData };
          }
        } catch (error) {
          console.error("Error creating ticket:", error);
          return { success: false };
        }
      }

      static async InsertSendToBankStatus(id) {
        try {
          const url = API_ENDPOINTS.InsertSendToBankStatus(id);
          const token = localStorage.getItem('token');
          const response = await axios.post(url,null, {
            headers: {
                "Authorization": `Bearer ${token}`
            },
          });
          
          const resultndData = response.data;
          if(resultndData.result> 0){
            
            return { success: true,data:resultndData };
          }else {
            
            return { success: false, data: resultndData };
          }
        } catch (error) {
          console.error("Error creating ticket:", error);
          return { success: false };
        }
      }

      static async InsertRejectStatus(id) {
        try {
          const url = API_ENDPOINTS.InsertRejectStatus(id);
          const token = localStorage.getItem('token');
          const response = await axios.post(url,null, {
            headers: {
                "Authorization": `Bearer ${token}`
            },
          });
          
          const resultndData = response.data;
          if(resultndData.result> 0){
            
            return { success: true,data:resultndData };
          }else {
            
            return { success: false, data: resultndData };
          }
        } catch (error) {
          console.error("Error creating ticket:", error);
          return { success: false };
        }
      }

      static async DeleteFile(fileName) {
        try {
          const url = API_ENDPOINTS.deleteExistingAttachment(encodeURIComponent(fileName));
          const token = localStorage.getItem('token');
          const response = await axios.post(url,null, {
            headers: {
                "Authorization": `Bearer ${token}`
            },
          });
          
          const resultndData = response.data;
          if(resultndData.result> 0){
            
            return { success: true,data:resultndData };
          }else {
            
            return { success: false, data: resultndData };
          }
        } catch (error) {
          console.error("Error creating ticket:", error);
          return { success: false };
        }
      }
}
    
export default ApprovalProcessService